const ToastType = {
  MAIN: 'tr5-main',
  VDP: 'tr5-vdp',
  PAYMENTS_ON_HOLD: 'tr5-paymentsOnHold'
};

export default ToastType;
